import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetMemberLoginHistory from '@/modules/manage-member/api/hooks/useQueryGetMemberLoginHistory'
import MemberLoginLogListing from '@/modules/manage-member/components/MemberLoginLog/components/MemberLoginLogListing'

function MemberLoginLogPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		username: searchQuery,
	}

	const { data, isLoading } = useQueryGetMemberLoginHistory(payload)

	return (
		<PageContainer>
			<MemberLoginLogListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedMemberLoginLogPage = withUserPermission(MemberLoginLogPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_OPERATOR],
})

export default GuardedMemberLoginLogPage
